import plural from 'plurals-cldr'

export interface PluralNoun {
  // keys are PluralForm
  zero?: string
  one?: string
  two?: string
  few?: string
  many?: string
  other?: string
}

export type PluralNounEn = Pick<PluralNoun, 'one' | 'other'>
export type PluralNounRu = Pick<PluralNoun, 'one' | 'few' | 'many'>
export const numberWithNounEn = (nouns: PluralNounEn) => (n: number) =>
  n + ' ' + (nouns as PluralNoun)[plural('en', n)]
export const numberWithNounRu = (nouns: PluralNounRu) => (n: number) =>
  n + ' ' + (nouns as PluralNoun)[plural('ru', n)]

export class LangUtil {
  public static stripMargin(str: string): string {
    const lines = str.split('\n')
    let minMargin = 0
    let noStrip = false
    lines.forEach((l: string) => {
      if (l.length && !l.startsWith(' ')) {
        noStrip = true
        return
      }
      const p = l.split(/^[ ]+/)
      if (p.length > 1 && p[1]) {
        const margin = l.indexOf(p[1])
        if (margin > 0 && (!minMargin || minMargin > margin)) {
          minMargin = margin
        }
      }
    })
    if (noStrip) {
      return str
    }
    return lines.map((l: string) => l.slice(minMargin)).join('\n')
  }
}
